import { render, staticRenderFns } from "./EducationModal.vue?vue&type=template&id=13ee62da&scoped=true&"
import script from "./EducationModal.vue?vue&type=script&lang=js&"
export * from "./EducationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee62da",
  null
  
)

export default component.exports